export default "__VITE_ASSET__8d6f0dc4__"